import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import * as SC from '../../style'
import { ReviewTheTransactionActivityProps } from './ReviewTheTransactionActivityProps'

export const ReviewTheTransactionActivity: FC<ReviewTheTransactionActivityProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <SC.MainText>
          Excessive commingling of funds with the personal account of the business’ owner(s), manager(s), or with
          accounts of seemingly unrelated businesses.
        </SC.MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SC.SecondText>
          Review the Quarterly Analytics for internal transfers and research the offsetting account.
        </SC.SecondText>
      </Col>
      <Col>
        <Field
          name="reviewTheTransactionActivityRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheTransactionActivityPurposeOfTransferBA"
          label="Purpose of the transfer(s) for business account?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'No Transactions of This Type',
                value: 'no_transactions'
              },
              {
                label: 'Transfer for Tax Purposes',
                value: 'tax_purposes'
              },
              {
                label: 'Transfer for Product Purchases',
                value: 'product_purchases'
              },
              {
                label: 'Transfer for Loan Payment',
                value: 'loan_payment'
              },
              {
                label: 'Transfer for Contribution/Distribution',
                value: 'contribution_distribution'
              },
              {
                label: 'Transfer for Credit Card Payments',
                value: 'card_payments'
              },
              {
                label: 'Unsure of Transfer Purpose – See Quarterly and/or Annual Review Questions',
                value: 'see_quarterly'
              },
              {
                label: 'Other – See Comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <SC.SecondText>Does the business owner(s)/account signer(s) have a consumer account?</SC.SecondText>
      </Col>
      <Col>
        <Field
          name="reviewTheTransactionActivityConsumerAccount"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheTransactionActivityPurposeOfTransferCA"
          label="Purpose of transfer(s) for consumer account?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'No Transactions of This Type',
                value: 'no_transactions'
              },
              {
                label: 'Transfer for Tax Purposes',
                value: 'tax_purposes'
              },
              {
                label: 'Transfer for Loan Payment',
                value: 'loan_payment'
              },
              {
                label: 'Transfer for Contribution/Distribution',
                value: 'contribution_distribution'
              },
              {
                label: 'Unsure of Transfer Purpose – See Quarterly and/or Annual Review Questions',
                value: 'see_quarterly'
              },
              {
                label: 'Other – See Comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTheTransactionActivityComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
